import { render, staticRenderFns } from "./CaseDetail.vue?vue&type=template&id=a1eae36c&scoped=true"
import script from "./CaseDetail.vue?vue&type=script&lang=js"
export * from "./CaseDetail.vue?vue&type=script&lang=js"
import style0 from "./CaseDetail.vue?vue&type=style&index=0&id=a1eae36c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1eae36c",
  null
  
)

export default component.exports